import { NgModule } from '@angular/core';
import { LibRefreshIconComponent } from './lib-refresh-icon.component';

@NgModule({
  declarations: [LibRefreshIconComponent],
  exports: [LibRefreshIconComponent],
})
export class LibRefreshIconModule {}
